class ICoreScrollToTop {
    button = null;
    scrollThreshold = 300;

    eventHandler = {};

    constructor(element, options = {}) {
        this.button = element;

        if (!this.button) {
            return;
        }

        if (options.scrollThreshold !== undefined) {
            this.scrollThreshold = options.scrollThreshold;
        }

        this.eventHandler = {
            scroll: this.onScroll.bind(this),
            click: this.onClick.bind(this),
        };

        this.#initEvents();
        this.onScroll();
    }

    #initEvents() {
        window.addEventListener('scroll', this.eventHandler.scroll);
        this.button.addEventListener('click', this.eventHandler.click);
    }

    onScroll() {
        this.button.classList.toggle('show', window.scrollY > this.scrollThreshold);
    }

    onClick() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    destroy() {
        window.removeEventListener('scroll', this.eventHandler.scroll);
        this.button.removeEventListener('click', this.eventHandler.click);
    }
}

export default ICoreScrollToTop;
